import { render } from "./lt.vue?vue&type=template&id=229d3c9c"
import script from "./lt.vue?vue&type=script&lang=js"
export * from "./lt.vue?vue&type=script&lang=js"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__